import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { CURRICULUM } from "./apiRoutes";

export interface CurriculumGradeItem {
  id: string;
  name: string;
}

export interface CurriculumGradesResponse {
  data: CurriculumGradeItem[];
}

const fetchCurriculumGrades = async () => {
  const response = await axiosAuth.get(CURRICULUM, { });
  return response.data as CurriculumGradesResponse;
};

export const useGetCurriculumGrades = (
  queryParams?: UseQueryOptions<CurriculumGradesResponse, Error, CurriculumGradesResponse, [string]>
) =>
  useQuery<CurriculumGradesResponse, Error, CurriculumGradesResponse, [string]>({
    queryKey: ["curriculum-grades"],
    queryFn: fetchCurriculumGrades,
    ...(queryParams as any),
  });


